import React from "react";
import styles from "./OpeningHours.css";
import { Icon, LIB } from "../../../../constants/consts-types";
import Svg from "../../../Svg/Svg";

export default function OpeningHours({
  opening_hours,
  content,
  isHD,
  showOpeningHours,
  setShowOpeningHours,
}) {
  return (
    <div
      className={[
        styles.OpeningHours,
        showOpeningHours ? styles["OpeningHours_active"] : "",
      ].join(" ")}
    >
      <a
        onClick={(e) => {
          e.preventDefault();
          setShowOpeningHours(!showOpeningHours);
        }}
        href={opening_hours.link ? opening_hours.link : ""}
        title={`${LIB.goto} ${opening_hours.message}`}
        className={[styles["OpeningHours-Link"]]}
        aria-label={opening_hours.message}
      >
        {!isHD ? (
          <div className={styles.Clock}>
            <Svg id={Icon.CLOCK} className={styles["Clock-Icon"]} />
          </div>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: opening_hours.message }} />
        )}
      </a>

      {showOpeningHours && (
        <div
          onClick={() => setShowOpeningHours(false)}
          className={styles["OpeningHours-Overlay"]}
        ></div>
      )}

      {isHD ? (
        <div className={styles["OpeningHours-Content"]}>
          <div
            style={{
              // TODO: Move to styles
              fontSize: "0.9rem",
              marginBottom: "3rem",
              textAlign: "right",
              cursor: "pointer",
            }}
            onClick={() => setShowOpeningHours(false)}
            dangerouslySetInnerHTML={{ __html: opening_hours.message }}
          />
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      ) : (
        <div className={styles["OpeningHours-Modal"]}>
          <div className={styles["OpeningHours-Content"]}>
            <p dangerouslySetInnerHTML={{ __html: opening_hours.message }} />
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/OpeningHours/OpeningHours.js